
import React from 'react';


const PasswordModal = ({ isOpen, password, onClose, userName }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 dark:bg-black/70 backdrop-blur-sm transition-all">
      <div className="bg-white dark:bg-slate-900 rounded-3xl shadow-2xl p-8 max-w-md w-full mx-4 transform transition-all border border-gray-100 dark:border-slate-800 border-t-4 border-t-cyan-500 dark:border-t-cyan-500">
        <div className="text-center">
          <div className="w-16 h-16 bg-cyan-100 dark:bg-cyan-900/30 text-cyan-600 dark:text-cyan-400 rounded-full flex items-center justify-center mx-auto mb-4">
            <i className="fas fa-key text-2xl"></i>
          </div>
          <h2 className="text-2xl font-bold text-gray-800 dark:text-slate-100 mb-2">Contraseña Generada</h2>
          <p className="text-gray-600 dark:text-slate-400 mb-6">
            La cuenta para <span className="font-semibold text-cyan-600 dark:text-cyan-400">{userName}</span> ha sido creada exitosamente.
          </p>
          
          <div className="bg-cyan-50 dark:bg-cyan-900/10 border border-cyan-100 dark:border-cyan-900/30 rounded-2xl p-4 mb-6 relative group">
            <span className="text-2xl font-mono tracking-widest text-cyan-800 dark:text-cyan-400 break-all select-all">
              {password}
            </span>
          </div>

          <p className="text-xs text-red-500 dark:text-red-400 mb-6 italic">
            * Asegúrese de copiar esta contraseña ahora. No volverá a mostrarse por seguridad.
          </p>

          <button
            onClick={onClose}
            className="w-full bg-cyan-600 hover:bg-cyan-700 text-white font-bold py-3 px-4 rounded-xl transition duration-200 shadow-lg shadow-cyan-200 dark:shadow-none"
          >
            Entendido, cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

export default PasswordModal;
